import { Box, IBoxProps } from 'native-base';
import { startCase, toLower } from 'lodash';
import moment from 'moment';

import { Text } from '@pimm/base';
import { useSimpleSite } from '../context/simple-site.context';

// Minimal types
type ReviewInfo = { reviewerUserName?: string; reviewTimestampUtc?: string };

type ReviewInfoSnippetProps = IBoxProps & {
  reviewer?: ReviewInfo & { userId?: string; userName?: string };
};

export const ReviewInfoSnippet = ({ reviewer, ..._boxProps }: ReviewInfoSnippetProps) => {
  const utcOffsetInMinutes = useSimpleSite(_ => _.site?.address?.utcOffsetInMinutes);
  const name = reviewer?.reviewerUserName ?? reviewer?.userName;
  const [username, firstName, lastName] = name?.split('$') ?? [];

  return (
    <Box {..._boxProps}>
      <Text size="md" fontWeight={500} color="gray.700" lineHeight="md">
        {firstName ? startCase(toLower([firstName, lastName].filter(Boolean).join(' '))) : username}
      </Text>

      {reviewer?.reviewTimestampUtc && (
        <Text size="md" fontWeight={400} color="gray.600" lineHeight="md">
          {moment
            .utc(reviewer.reviewTimestampUtc)
            .utcOffset(utcOffsetInMinutes ?? 0)
            .format('MM/DD/YYYY h:mm A')}
        </Text>
      )}
    </Box>
  );
};
